/* eslint-disable no-mixed-spaces-and-tabs */
import { createSelector } from 'reselect';
import { initialState } from './reducer';

export const selectIcepacksFilledContainerDomain = state => state.icepacksFilledContainerReducer || initialState;

export const getIsIcepacksFilledLoadingSelector = () =>
	createSelector(selectIcepacksFilledContainerDomain, ({ isIcepacksFilledLoading }) => isIcepacksFilledLoading);

export const getIcepacksFilledSelector = () =>
	createSelector(selectIcepacksFilledContainerDomain, ({ icepacksFilled }) => {
		return icepacksFilled;
	});

export const getPaginationSelector = () =>
	createSelector(selectIcepacksFilledContainerDomain, ({ pagination }) => {
		if (!pagination || pagination?.total === 0) {
			return null;
		}

		return {
			currentPage: pagination.current_page,
			totalPages: pagination.last_page,
			perPage: pagination.per_page,
			total: pagination.total,
			from: pagination.current_page * pagination.per_page - (pagination.per_page - 1),
			to:
				pagination.current_page === pagination.last_page
					? pagination.total
					: pagination.current_page * pagination.per_page,
			isNextItem: true,
			isPrevItem: true,
			isLastItem: false,
			isFirstItem: false,
		};
	});

export const getIcepacksFillersOptionsSelector = () =>
	createSelector(selectIcepacksFilledContainerDomain, ({ icepacksFillers }) => icepacksFillers);

export const getIsIcepacksFillersLoadingSelector = () =>
	createSelector(selectIcepacksFilledContainerDomain, ({ isIcepacksFillersLoading }) => isIcepacksFillersLoading);

export const getIcepacksStatesOptionsSelector = () =>
	createSelector(selectIcepacksFilledContainerDomain, ({ icepacksStates }) => icepacksStates);

export const getIsIcepacksStatesLoadingSelector = () =>
	createSelector(selectIcepacksFilledContainerDomain, ({ isIcepacksStatesLoading }) => isIcepacksStatesLoading);

export const getModesOptionsSelector = () => createSelector(selectIcepacksFilledContainerDomain, ({ modes }) => modes);

export const getIsModesLoadingSelector = () =>
	createSelector(selectIcepacksFilledContainerDomain, ({ isModesLoading }) => isModesLoading);
